// require-default-propsはtypescriptの場合は不要
/* eslint-disable react/require-default-props */

import React, { useState } from "react";

type Props = {
  title: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

function PortalPCCollapsibleSection({
  title,
  collapsible = true,
  defaultOpen = false,
  children,
}: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  // NOTE: サイドバー内でtitleは一意なのでidに使う（SSR時もサーバ/クライアントで一致する）
  const bodyId = `portal-pc-sidebar-section-${title.replace(/\s+/g, "-")}`;

  if (!collapsible) {
    return (
      <div className="portalPcSidebarSection">
        <div className="portalPcSidebarSectionHeader">
          <h3 className="portalPcSidebarSectionTitle">{title}</h3>
        </div>
        <div className="portalPcSidebarSectionBody">{children}</div>
      </div>
    );
  }

  return (
    <div className="portalPcSidebarSection isCollapsible">
      <button
        type="button"
        className="portalPcSidebarSectionHeader"
        aria-expanded={isOpen}
        aria-controls={bodyId}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="portalPcSidebarSectionTitle">{title}</span>
        <i
          className={`fa fa-angle-${
            isOpen ? "up" : "down"
          } portalPcSidebarChevron`}
          aria-hidden="true"
        />
      </button>
      {isOpen && (
        <div id={bodyId} className="portalPcSidebarSectionBody">
          {children}
        </div>
      )}
    </div>
  );
}

export default PortalPCCollapsibleSection;
